export default __webpack_public_path__ + "static/media/5.d5ba344d.jpg";